import React from "react";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { message } from "antd";
import { push } from "connected-react-router";
import authLayout from "components/auth-layout";
import Loading from "components/loading";
// import Login from 'containers/login';
// import Register from 'containers/register';
// import VerifyAccount from 'containers/verify-account';
// import Dashboard from 'containers/dashboard';
import Home from 'containers/home';
import Listings from "containers/listings";
import ListingDetails from "containers/listing-details";
import Mappings from "containers/mappings";
import Orders from "containers/orders";
import BulkOrdersList from 'containers/bulk-order/list';
import CSVOrder from 'containers/bulk-order/csv-order';
import SettingsProfile from "containers/settings-profile";
import SettingsStores from "containers/settings-stores";
import BulkMapping from "containers/mapping-bulk";
import BulkOrderCreate from "containers/bulk-order/create";
import EtsyCallback from "containers/etsy-callback";
import Help from "containers/help";
import Prep from "containers/prep";

import AdminDashboard from 'admin/dashboard';
import AdminUserMappings from 'admin/mappings';

import { sessionActions } from "redux/modules/session";
import { labActions } from "redux/modules/lab";
import * as Sentry from "@sentry/browser";

const HomeView = authLayout(Home);
const MappingView = authLayout(Mappings);
const SettingsView = authLayout(SettingsStores);
const SettingsProfileView = authLayout(SettingsProfile);
const OrdersView = authLayout(Orders);
const ListingDetailsView = authLayout(ListingDetails);
const ListingsView = authLayout(Listings);
const HelpView = authLayout(Help);
const BulkMappingView = authLayout(BulkMapping);
const BulkOrderCreateView = authLayout(BulkOrderCreate);
const BulkOrderListView = authLayout(BulkOrdersList);
const CSVOrderView = authLayout(CSVOrder);
const PrepView = authLayout(Prep);
const EtsyCallbackView = authLayout(EtsyCallback);

const AdminDashboardView = authLayout(AdminDashboard);
const AdminUserMappingsView = authLayout(AdminUserMappings);

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, eventId: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      Sentry.showReportDialog({ eventId });
    });
  }

  componentWillMount() {
    this.props.dispatch(labActions.getLabData());
    this.props.dispatch(labActions.getCatalog());
    this.props.dispatch(sessionActions.getMe()).then(resp => {
      if (!resp) {
        this.props.history.push("/settings");
      } else {
        // Nothing to do now.
      }
    });
  }
  render() {
    const { loading, user } = this.props;
    if (loading || !user) {
      return <Loading />;
    }

    if (this.state.hasError) {
      return (
        <div className="text-center" style={{ padding: 30}}>
          <h1>There was an error</h1>
          <a href="/">Go back to home</a>
        </div>
      )
    }

    return (
      <Switch>
        <Route exact path="/" component={HomeView} />
        <Route exact path="/listings" component={ListingsView} />
        <Route exact path="/listings/:id" component={ListingDetailsView} />
        <Route exact path="/orders" component={OrdersView} />
        <Route path="/mappings" component={MappingView} />
        <Route exact path="/bulk-mapping" component={BulkMappingView} />
        <Route exact path="/bulk-orders" component={BulkOrderListView} />
        <Route exact path="/bulk-orders/create" component={BulkOrderCreateView} />
        <Route exact path="/bulk-orders/csv-order" component={CSVOrderView} />
        <Route exact path="/help" component={HelpView} />
        <Route exact path="/settings" component={SettingsProfileView} />
        <Route path="/settings/stores" component={SettingsView} />
        <Route exact path="/prep" component={PrepView} />
        <Route exact path="/etsy/callback" component={EtsyCallbackView} />

        <Route exact path="/admin" component={AdminDashboardView} />

        <Redirect to="/" />
      </Switch>
    );
  }
}

export default withRouter(connect(state => state.session)(Main));
